<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w9f3Gu/tc-custom/9781644058886.jpg?1718184629998" alt="This image is the cover for the book School of Fish, Fish Out of Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">School of Fish, Fish Out of Water
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Fish Out of Water: Book Six</i></b></p><p>Jackson Rivers has been learning how to take care of himself so he can be there for Ellery Cramer, but after eight weeks of healing, body and soul, he’s itching to get back to work. Finally Ellery gives him a simple task: pick up a file on a kid who probably didn’t commit murder but who refuses to participate in his own defense.</p><p>Nothing is ever that easy.</p><p>A horrifying game of connect-the-dots leads one case to another, to the mob, to the local high school… and a bottomless list of potential suspects and victims. The case has a lot of moving parts, and Jackson and Ellery have to work fast to make sure the machinery of the mob doesn’t mow down everyone they care about—or rip them apart.</p><p>After a year of living together, Ellery is learning to accept that Jackson can’t let an injustice stand. Together they fight to keep kids out of jail while the streets of Sacramento threaten to explode. They’d better hope they’ve learned enough about each other to keep it together, because for this case, school is the most dangerous place to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      <p class="authorDescription body article"><P>Award winning author Amy Lane lives in a crumbling crapmansion with a couple of teenagers, a passel of furbabies, and a bemused spouse. She has too damned much yarn, a penchant for action-adventure movies, and a need to know that somewhere in all the pain is a story of Wuv, Twu Wuv, which she continues to believe in to this day! She writes contemporary romance, paranormal romance, urban fantasy, and romantic suspense, teaches the occasional writing class, and likes to pretend her very simple life is as exciting as the lives of the people who live in her head. She&rsquo;ll also tell you that sacrifices, large and small, are worth the urge to write.</P><P>Website: www.greenshill.com</P><P>Blog: www.writerslane.blogspot.com</P><P>Email: amylane@greenshill.com</P><P>Facebook: www.facebook.com/amy.lane.167</P><P>Twitter: @amymaclane</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bb33cec